var moduleMap = {
	"./BehSmartGroup": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_ps-refarch-ux_neon_lib_esm_lib-index_js-node_modules_css-loader_dist_run-615641"), __webpack_require__.e("node_modules_moment_locale_sync_recursive_-module-federation_initialize-beh-smart-group_tsx-w-aa4ee3")]).then(() => (() => ((__webpack_require__(/*! ./module-federation/initialize-beh-smart-group */ "./module-federation/initialize-beh-smart-group.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});